module.exports = [
  require("./text"),
  require("./css"),
  require("./less"),
  require("./javascript"),
  require("./typescript"),
  require("./html"),
  require("./shell"),
  require("./marko")
]
